// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".catalogProductPage_txCFL{position:relative}", ""]);
// Exports
exports.locals = {
	"catalogProductPage": "catalogProductPage_txCFL"
};
module.exports = exports;
